module.exports = __webpack_public_path__ + "static/team_img-a230ff4847cc05220307d45e967b4e70.jpg";